import { formatNumber } from '../../../utils/usefulFunctions';

export const viewModelStructure = {
    SupplierBookingStatus: {
        SupplierBookingStatusType: {
            Name: true,
        },
    },
    SupplierHotel: {
        Name: true,
    },
    BookingCode: true,
    CheckInDate: true,
    CheckOutDate: true,
    BookingDate: true,
    Nights: true,
    Paxes: true,
    TotalAmount: true,
    Currency: {
        Key: true,
    },
    SupplierBookingPaymentInfo: {
        CreditCardNumberObfuscated: true,
        HolderName: true,
        HolderSurname: true,
        IdVirtualCreditCard: true,
        VirtualCreditCard: {
            CVV: true,
            CardNumber: true,
        },
    },
    ReservationIDs: {
        ResID_Value: true,
        OTAReferenceTableCode: {
            Key: true,
        },
    },
    SupplierBookingRequest: true,
    Rooms: {
        SupplierHotelMealPlan: {
            Name: true,
            MappingCode: true,
        },
        SupplierHotelRoomType: {
            Name: true,
            Description: true,
            MappingCode: true,
        },
        Paxes: {
            Age: true,
            Name: true,
            Surname: true,
            IsAdult: true,
            IsBaby: true,
            IsChild: true,
        },
        Rates: {
            AmountAfterTax: true,
        },
        SupplierHotelRatePlan: {
            MappingCode: true,
            Name: true,
        },
    },
    Remarks: true,
    SupplierBookingCancellationPolicy: {
        DecodedPenalties: true,
    },
    ZoeBooking: {
        ExternalReferenceCodes: true,
        EndCustomer: {
            Name: true,
            Surname: true,
            EmailAddress: true,
        },
    },
};

export const detailInitialState = {
    SupplierBookingStatus: {
        SupplierBookingStatusType: {
            Name: '',
        },
    },
    SupplierHotel: {
        Name: '',
    },
    SupplierBookingPaymentInfo: {
        CreditCardNumberObfuscated: '',
        HolderName: '',
        HolderSurname: '',
        IdVirtualCreditCard: 0,
        VirtualCreditCard: {
            CVV: '',
            CardNumber: '',
        },
    },
    ReservationIDs: {
        ResID_Value: '',
        OTAReferenceTableCode: {
            Key: '',
        },
    },
    BookingCode: '',
    CheckInDate: '',
    CheckOutDate: '',
    BookingDate: '',
    Nights: 0,
    Paxes: 0,
    TotalAmount: '',
    Currency: {
        Name: '',
    },
    Remarks: '',
    ZoeBooking: {
        ExternalReferenceCodes: '',
        EndCustomer: [
            {
                Name: '',
                Surname: '',
                EmailAddress: '',
            },
        ],
        Rooms: [
            {
                HotelMealPlan: {
                    Name: '',
                    MappingCode: '',
                },
                HotelRoomType: {
                    Name: '',
                    Description: '',
                    MappingCode: '',
                },
                Paxes: [
                    {
                        Age: '',
                        Name: '',
                        Surname: '',
                        IsAdult: '',
                        IsBaby: '',
                        IsChild: '',
                    },
                ],
                SupplierHotelRatePlan: {
                    MappingCode: '',
                    Name: '',
                },
                Rates: [
                    {
                        Amount: '',
                        SellCurrencyAmount: '',
                        Currency: {
                            Key: '',
                        },
                    },
                ],
            },
        ],
        CancellationPolicy: {
            DecodedPenalties: [''],
        },
    },
};

export const cleanSingleBookingData = booking => {
    const findHotelRef = IdList => {
        const refObject = IdList.find(
            item => item.OTAReferenceTableCode.Key === '10'
        );
        return refObject?.ResID_Value || '';
    };

    const hotelRef =
        booking?.ReservationIDs.length && findHotelRef(booking?.ReservationIDs);

    const client = booking?.ZoeBooking.EndCustomer;

    return {
        BookingCode: booking.BookingCode,
        Status: booking.SupplierBookingStatus.SupplierBookingStatusType.Name,
        BookingDate: booking.BookingDate,
        Hotel: booking.SupplierHotel.Name,
        BookingReferenceHotel: hotelRef,
        CheckIn: booking.CheckInDate,
        CheckOut: booking.CheckOutDate,
        Nights: booking.Nights,
        Guests: booking.Paxes,
        Price:
            booking?.Currency?.Key && booking?.TotalAmount
                ? formatNumber(
                      booking?.TotalAmount,
                      'currency',
                      booking.Currency.Key
                  ) + ` (${booking.Currency.Key})`
                : booking?.TotalPrice
                ? formatNumber(booking?.TotalPrice, 'decimal')
                : booking?.TotalPrice,
        PaymentInfo:
            booking?.SupplierBookingPaymentInfo?.CreditCardNumberObfuscated,
        CancellationPolicy:
            booking?.SupplierBookingCancellationPolicy?.DecodedPenalties,
        Notes: booking?.Remarks,
        ClientName: client.Name,
        ClientSurname: client?.Surname,
        EmailAdress: client?.EmailAddress,
    };
};

export const filterColumnGrid = { xs: 12, sm: 12, md: 6, lg: 4, xl: 4 };
export const filterDateColumnGrid = { xs: 12, sm: 12, md: 6, lg: 4, xl: 2 };
